<script setup>
const enter = (element) => {
	const width = getComputedStyle(element).width

	element.style.width = width
	element.style.position = 'absolute'
	element.style.visibility = 'hidden'
	element.style.height = 'auto'

	const height = getComputedStyle(element).height

	element.style.width = null
	element.style.position = null
	element.style.visibility = null
	element.style.height = element.parentElement.style.height || '0'
	element.style.opacity = '0'

	getComputedStyle(element).height
	requestAnimationFrame(() => {
		element.parentElement.style.height = height
		element.style.height = height
		element.style.opacity = '1'
	})
}

const afterEnter = (element) => {
	element.style.height = 'auto'
	element.parentElement.style.height = 'auto'
}

const leave = (element) => {
	const height = getComputedStyle(element).height
	const newElement = element.parentElement.querySelector(':scope > [data-v-expand-enter]')
	const newHeight = newElement ? getComputedStyle(newElement).height : '0'

	element.style.height = height
	element.style.opacity = '1'
	element.parentElement.style.height = height

	getComputedStyle(element).height

	requestAnimationFrame(() => {
		element.style.height = newHeight
		element.style.opacity = '0'
		element.parentElement.style.height = newHeight
	})
}
</script>

<template>
	<div class="trans-fade-wrapper">
		<transition name="trans-fade" @enter="enter" @after-enter="afterEnter" @leave="leave">
			<slot />
		</transition>
	</div>
</template>

<style scoped>
* {
	@apply transform-gpu will-change-[height,opacity];
	backface-visibility: hidden;
	-webkit-perspective: 1000;
	-moz-perspective: 1000;
	-ms-perspective: 1000;
	perspective: 1000;
}

.trans-fade-wrapper {
	@apply relative transition-[height] duration-500 ease-[ease];
}
</style>

<style>
.trans-fade-enter-active,
.trans-fade-leave-active {
	@apply absolute w-full overflow-hidden transition-[opacity] duration-500 ease-[ease];
}

.trans-fade-enter-from,
.trans-fade-leave-to {
	@apply opacity-0;
}

.trans-fade-enter-to,
.trans-fade-leave-from {
	@apply opacity-100;
}

[data-v-trans-fade-enter] {
	@apply invisible absolute;
}
</style>
